import { render, staticRenderFns } from "./rolePowerEdit.vue?vue&type=template&id=96b9e7dc&scoped=true&"
import script from "./rolePowerEdit.vue?vue&type=script&lang=js&"
export * from "./rolePowerEdit.vue?vue&type=script&lang=js&"
import style0 from "./rolePowerEdit.vue?vue&type=style&index=0&id=96b9e7dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b9e7dc",
  null
  
)

export default component.exports